// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Lo-z","slideIn":"Mo-z"};